import AdminNav from '#utils/nav-role/nav-admin';
import AfterSaleNav from '#utils/nav-role/nav-after-sale';
import CommunityManagerNav from '#utils/nav-role/nav-community-manager';
import ManagerNav from '#utils/nav-role/nav-manager';
import SalesAdvisorNav from '#utils/nav-role/nav-sales-advisor';
/* tslint:disable:max-line-length */
import SuperAdminNav from '#utils/nav-role/nav-super-admin';
import { STORAGE_KEYS } from '#utils/local-storage/local-storage.service';

export default function defaultNavigation() {
    const rol = localStorage.getItem(STORAGE_KEYS.ROLE);
    const isSuperAdmin = rol === "SuperAdmin";
    const isAfterSale = rol === "AfterSale";
    const isManager = rol === "Manager";
    const isCommunityManager = rol === "CommunityManager";
    const isSalesAdvisor = rol === "SalesAdvisor";
    const isAdmin = rol === "Admin";

    if (isSuperAdmin) {
        return SuperAdminNav();
    }
    if (isAfterSale) {
        return AfterSaleNav();
    }

    if (isSalesAdvisor) {
        return SalesAdvisorNav();
    }

    if (isManager) {
        return ManagerNav();
    }

    if (isCommunityManager) {
        return CommunityManagerNav();
    }

    if (isAdmin) {
        return AdminNav();
    }
}
